const TravelReducer = (state = { user: {} }, action) => {
  switch (action.type) {
    case "BLOGS":
      return { ...state, blogs: action.payload };
    default:
      return state;
  }
};

export default TravelReducer;
